import React, { FC } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { ArrayElement } from '@shared/lib/types';
import { newYearPrizes, newYearPrizesWithResult } from '../../config/new-year/prizes';
interface PrizeItemProps {
  index: number;
  prize: ArrayElement<typeof newYearPrizes | typeof newYearPrizesWithResult>;
}
const PrizeItem: FC<PrizeItemProps> = ({
  index,
  prize
}) => {
  const isResult = 'description' in prize;
  return <PrizeItemWrapper isResult={isResult}>
      <BgPlate index={index} isResult={isResult} />
      <ImageWrapper isResult={isResult}>
        <Image src={prize.img} alt={prize.label} width={370} height={460} />
      </ImageWrapper>
      <TextWrapper isResult={isResult}>{prize.label}</TextWrapper>
      {isResult && <DescriptionWrapper>{prize.description}</DescriptionWrapper>}
    </PrizeItemWrapper>;
};
export default PrizeItem;
const _exp = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '550px' : '350px';
const PrizeItemWrapper = /*#__PURE__*/styled('div')({
  name: "PrizeItemWrapper",
  class: "pga4rva",
  propsAsIs: false,
  vars: {
    "pga4rva-0": [_exp()]
  }
});
const _exp2 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '110%' : '95%';
const _exp3 = /*#__PURE__*/() => ({
  index,
  isResult
}) => isResult ? ["linear-gradient(358.63deg, #A27206 1.16%, #EBD45D 120.68%)", "linear-gradient(180deg, #E6E6E6 -25.66%, #666666 100%)", "linear-gradient(180deg, #AF7D50 0%, #5D3613 100%)"][index] : '#2a8666';
const _exp4 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '110%' : '100%';
const _exp5 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '350px' : '280px';
const BgPlate = /*#__PURE__*/styled('div')({
  name: "BgPlate",
  class: "b12bohyw",
  propsAsIs: false,
  vars: {
    "b12bohyw-0": [_exp2()],
    "b12bohyw-1": [_exp3()],
    "b12bohyw-2": [_exp4()],
    "b12bohyw-3": [_exp5()]
  }
});
const _exp6 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '-120px' : '-60px';
const _exp7 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? 'auto' : '200px';
const _exp8 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '-160px' : '-60px';
const _exp9 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '-10px' : '10px';
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "i14d1zv3",
  propsAsIs: false,
  vars: {
    "i14d1zv3-0": [_exp6()],
    "i14d1zv3-1": [_exp7()],
    "i14d1zv3-2": [_exp8()],
    "i14d1zv3-3": [_exp9()]
  }
});
const _exp0 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '50px' : 'calc(0.8335vw * 2.5)';
const _exp1 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '-28px' : 'calc(0.8335vw * -1.5)';
const _exp10 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '36px' : 'calc(0.8335vw * 1.75)';
const _exp11 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '50px' : 'calc(0.8335vw * 2.75)';
const _exp12 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '-28px' : 'calc(0.8335vw * -1.575)';
const _exp13 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '36px' : 'calc(0.8335vw * 2.75)';
const _exp16 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '48px' : '20px';
const _exp17 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '40px' : '44px';
const _exp18 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '-36px' : '-45px';
const _exp19 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '60px' : '20px';
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t10tv3db",
  propsAsIs: false,
  vars: {
    "t10tv3db-0": [_exp0()],
    "t10tv3db-1": [_exp1()],
    "t10tv3db-2": [_exp10()],
    "t10tv3db-3": [_exp11()],
    "t10tv3db-4": [_exp12()],
    "t10tv3db-5": [_exp13()],
    "t10tv3db-6": [_exp17()],
    "t10tv3db-7": [_exp18()],
    "t10tv3db-8": [_exp16()],
    "t10tv3db-9": [_exp19()]
  }
});
const DescriptionWrapper = /*#__PURE__*/styled('div')({
  name: "DescriptionWrapper",
  class: "d16kdkfx",
  propsAsIs: false
});

require("./PrizeItem.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./PrizeItem.tsx");